import React from "react";
import InfoTip from "./InfoTip";

/**
 * A labelled value for detail pages. Empty values show "Sem informação" so
 * every field is always listed; `children` customizes how a filled value is
 * shown (links, badges, ...).
 *
 * `info` adds an info icon beside the label, explaining the field on hover.
 *
 * @param {{label: string, value?: string|null, children?: React.ReactNode, preserveLineBreaks?: boolean, info?: string}} props
 */
const Field = ({label, value, children, preserveLineBreaks = false, info}) => (
    <div className="mb-2">
        <div className="small text-muted d-flex align-items-center gap-1">
            {label}
            {info && <InfoTip>{info}</InfoTip>}
        </div>
        <div style={preserveLineBreaks ? {whiteSpace: "pre-wrap"} : undefined}>
            {value?.trim() ? (children ?? value) : <span className="text-muted">Sem informação</span>}
        </div>
    </div>
);

export default Field;
